@if(this.opCocaVitrine){
    @if(this.isFetching){
        <div class="bloc_loading">
            <ion-spinner></ion-spinner>
        </div>
    }
    @else{
        <app-mission-additional-data [operationId]="this.opCocaVitrine.id" [data]="this.additionalsDatas" [canEdit]="this.canEdit" (onChangeAdditionalsDatas)="this.onChangeAdditionalsDatas($event)"/>
    }
}

